import * as yup from 'yup';
import { VALIDATION_MESSAGE } from '../constants/Constants';
import { LanguageConstants } from '../constants/LanguageConstants';
const emojiFreeRegex = /^[\w\s\.,'!&@()-]+$/;



const profileValidation: any = yup.object().shape({
    name: yup.string().required(LanguageConstants?.PLEASE_ENTER_NAME)
        .min(3, LanguageConstants?.NAME_MIN)
        .max(25, LanguageConstants?.NAME_MAX)
        .matches(/^(?!.*\s{2,}).*$/, "Name cannot contain consecutive spaces")
        .matches(emojiFreeRegex, (LanguageConstants?.Emojis)),

    email: yup.string().required(LanguageConstants?.PLEASE_ENTER_Email)
        .email(LanguageConstants.EMAIL_ADDRESS)
        .matches(VALIDATION_MESSAGE.EMAIL_REGREX, LanguageConstants.EMAIL_ADDRESS)
        .max(150, LanguageConstants?.EMAIL_MAX)
        .trim(),
        phone_number: yup.string()
        .optional() 
        .test('phone-required', LanguageConstants.VALID_PHONE, (value:any) => {
            if (value && value.trim().length > 0) {
                return yup.string()
                    .min(7, LanguageConstants.PHONE_NUMBER_VALID)  
                    .max(15, LanguageConstants.PHONE_MAX_CHAR) 
                    .matches(/^[0-9]*$/, LanguageConstants.VALID_PHONE_NUMBER) // Only digits allowed
                    .test('valid-phone', LanguageConstants.VALID_PHONE, (value:any) => {
                        if (/^0+$/.test(value)) {
                            return false;
                        }
                        return true;
                    })
                    .isValidSync(value); // Validate synchronously
            }
            return true; // Return true if no phone number is entered (no error)
        }),
        phone_country_code: yup.string().required(),

   

});

export default profileValidation;

